import authReducers from './authReducers';
import clientPluginsReducers from './clientPluginsReducers';
import communicationReducers from './communicationReducers';
import conversionReducers from './conversionReducers';
import daylightReducers from './daylightReducers';
import eventsReducers from './eventsReducers';
import groupsReducers from './groupsReducers';
import metaReducers from './metaReducers';
import missionControlReducers from './missionControlReducers';
import newRequestPracticeReducers from './newRequestPracticeReducers';
import notesReducers from './notesReducers';
import offeringReducers from './offeringReducers';
import partnerReducers from './partnerReducers';
import pimsReducers from './pimsReducers';
import practiceAlertsReducers from './practiceAlertsReducers';
import practiceReducers from './practiceReducers';
import practiceWorkflowReducers from './practiceWorkflowReducers';
import relationsReducers from './relationsReducers';
import tagsReducers from './tagsReducers';
import toggleReducers from './toggleReducers';
import usersReducers from './usersReducers';
import viewReducers from './viewReducers';
import { reducer as formReducer } from 'redux-form';

const configureReducers = (services) => {
    const reducers = {
        auth: authReducers,
        clientPlugins: clientPluginsReducers,
        communication: communicationReducers,
        conversions: conversionReducers,
        daylight: daylightReducers,
        events: eventsReducers,
        form: formReducer,
        groups: groupsReducers,
        meta: metaReducers,
        missionControl: missionControlReducers,
        newRequestPractice: newRequestPracticeReducers,
        notes: notesReducers,
        offering: offeringReducers,
        partner: partnerReducers,
        pims: pimsReducers,
        practice: practiceReducers,
        practiceAlerts: practiceAlertsReducers,
        practiceWorkflow: practiceWorkflowReducers,
        relations: relationsReducers,
        tags: tagsReducers,
        toggle: toggleReducers,
        users: usersReducers,
        view: viewReducers,
    };
    return reducers;
};

export default configureReducers;
